"use strict";

angular.module("internal.exams").controller("InternalExamSkills", [
    "$scope",
    "EXSkill",
    "EXSkillCategory",
    "Permissions",
    "$q",
    function ($scope, EXSkill, EXSkillCategory, Permissions, $q) {
        $scope.loading = true;
        $scope.skillCategoriesFilter = [];
        $scope.bulkActionItems = [];
        $scope.bulkActionRunning = false;

        $scope.getSkills = function (bulkApply, status) {
            EXSkill.get().then(function (Skills) {
                Skills.forEach(function (skill) {
                    skill.options.forEach(function (option) {
                        if (skill.description != null) {
                            skill.title = skill.description.replace(/(<([^>]+)>)/ig, ''); // remove html tags
                            skill.title = skill.title.replace(/&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-f]{1,6});/ig, ''); // remove html elements
                        }
                        skill.total_points += option.points;
                    })
                })
                $scope.Skills = Skills;
                $scope.loading = false;
            });
        }

        $scope.getSkills();

        EXSkillCategory.get().then(function (SkillCategories) {
            $scope.SkillCategories = SkillCategories;
            var x, format;
            for (x in $scope.SkillCategories) {
                format = {
                    name: $scope.SkillCategories[x].name,
                    id: $scope.SkillCategories[x].name
                };
                $scope.skillCategoriesFilter.push(format);
            }
            $scope.loading = false;
        });

        Permissions.edit('internal.exams.administrative.skills').then(function (access) {
            $scope.bulkActionAccess = access;
        });

        $scope.setActive = function (bulkApply, status) {//bulk function
            $scope.bulkActionRunning = true;
            bulkApply.isOpen = false;
            var promises = [];
            if (status != null && $scope.bulkActionItems.length > 0) {
                promises.push(EXSkill.updateActive($scope.bulkActionItems, status).then(
                    function () { })
                );
            }
            $q.all(promises).then(function () {
                $scope.bulkActionItems = [];
                $scope.getSkills();
                $scope.bulkActionRunning = false;
            }).catch(function (response) {
                // handle error
            });
        };

        $scope.setCritical = function (bulkApply, status) {//bulk function
            $scope.bulkActionRunning = true;
            bulkApply.isOpen = false;
            var promises = [];
            if (status != null && $scope.bulkActionItems.length > 0) {
                promises.push(EXSkill.updateCritical($scope.bulkActionItems, status).then(
                    function () { })
                );
            }
            $q.all(promises).then(function () {
                $scope.bulkActionItems = [];
                $scope.getSkills();
                $scope.bulkActionRunning = false;
            }).catch(function (response) {
                // handle error
            });
        };

        $scope.setCategory = function (bulkApply, status) {//bulk function
            $scope.bulkActionRunning = true;
            bulkApply.isOpen = false;
            var promises = [];
            if (status != null && $scope.bulkActionItems.length > 0) {
                promises.push(EXSkill.updateCategory($scope.bulkActionItems, status).then(
                    function () { })
                );
            }
            $q.all(promises).then(function () {
                $scope.bulkActionItems = [];
                $scope.getSkills();
                $scope.bulkActionRunning = false;
            }).catch(function (response) {
                // handle error
            });
        };


        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.administrative.skill",
                    params: [
                        {
                            name: "examSkillID",
                            field: "id"
                        }
                    ]
                }
            },
            {
                label: "Code",
                field: "code"
            },
            {
                label: "Active",
                field: "active_status",
                type: "yesno"
            },
            {
                label: "Critical",
                field: "critical",
                type: "yesno"
            },
            {
                label: "Category",
                field: "exam_skill_category_name"
            },
            {
                label: "Total Points",
                field: "total_points"
            },
            {
                label: "Last Modified",
                field: "modifiedon",
                type: "datetime"
            },
            {
                label: "Modified By",
                field: "modifiedby"
            }
        ];

        $scope.filters = [
            {
                name: "Active",
                field: "active_status",
                options: [
                    { name: "Not Active", id: false },
                    { name: "Active", id: true }
                ]
            },
            {
                name: "Critical",
                field: "critical",
                options: [
                    { name: "Not Critical", id: false },
                    { name: "Critical", id: true }
                ]
            },
            {
                name: "Category",
                field: "exam_skill_category_name",
                options: $scope.skillCategoriesFilter
            }
        ];
    }
]);
